(function() { window.GUID_2c941646_2834_417a_abbf_1b2cc372a270 = { getGuid: function() { return "2c941646-2834-417a-abbf-1b2cc372a270"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    class FloatingSpares {
                        static RefreshSection() {
                            let accordion = CS.Controls.GetInstance(CS.Controls.Accordion, '.accordion-floatingspares', true);
                            if (accordion != null) {
                                accordion.RefreshContent();
                            }
                        }
                    }
                    WallSections.FloatingSpares = FloatingSpares;
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=floating-spares.js.map
